var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardDoubleArrowUp = function SvgKeyboardDoubleArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "keyboard_double_arrow_up_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#keyboard_double_arrow_up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.825 8.1 17.7a.98.98 0 0 1-.687.288.93.93 0 0 1-.713-.288.95.95 0 0 1-.275-.7q0-.425.275-.7l4.6-4.6q.15-.15.325-.212.175-.063.375-.063t.375.063a.9.9 0 0 1 .325.212l4.6 4.6q.276.274.287.688a.93.93 0 0 1-.287.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275zm0-6L8.1 11.7a.98.98 0 0 1-.687.288.93.93 0 0 1-.713-.288.95.95 0 0 1-.275-.7q0-.425.275-.7l4.6-4.6q.15-.15.325-.212.175-.063.375-.063t.375.063a.9.9 0 0 1 .325.212l4.6 4.6q.276.274.287.688a.93.93 0 0 1-.287.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275z"
  }))));
};
export default SvgKeyboardDoubleArrowUp;